<template>
  <div
    v-if="isRelevant"
    class="wt2-sg wt-transition-button"
    v-tooltip="$_tooltip_onToggle"
    ref="tooltipBody"
  >
    <i class="wticon wticon-Transitions" />

    <span class="wt2-text-n wt2-link" @click="choosePresetGroup">{{
      'transition.CHOOSE' | culture
    }}</span>

    <wt-toggle v-model="autoShuffle" @toggle="onToggleChange" />
  </div>
</template>

<script>
import Vue from 'vue';
import { mapState } from 'vuex';
import app from 'app';
import ChooseTransition from './ChooseTransition.vue';
import _ from 'lodash-extended';

export default Vue.extend({
  data() {
    const story = app.storyController.story;
    return {
      currentTransition: story.get('transitionSelection').selectedPreset,
      autoShuffle: this.$_shouldAutoShuffle(),
    };
  },

  computed: {
    ...mapState({
      transitionPresets: (state) => state.story.themeInfo.transitionPresets,
    }),

    isRelevant() {
      return this.transitionPresets.length > 0;
    },

    $_tooltip_onToggle() {
      let title;
      let description;

      if (this.autoShuffle) {
        title = app.culture.get('transition.tooltip.on.title');
        description = app.culture.get('transition.tooltip.on.description');
      } else {
        title = app.culture.get('transition.tooltip.off.title');
        description = app.culture.get('transition.tooltip.off.description');
      }

      return {
        animation: false,
        wrapperClass: 'large -transition',
        trigger: 'hover',
        placement: 'top',
        delay: { show: 300, hide: 0 },
        title: `
          <div class="transition-tooltip">
            <div class="-title">${title}</div>
            <div class="-description">${description}</div>
          </div>
        `.normalizeSpace(),
        html: true,
      };
    },
  },

  watch: {
    transitionPresets(newTransitionPresets) {
      if (
        !_.some(newTransitionPresets, { name: this.currentTransition }) &&
        newTransitionPresets.length > 0
      ) {
        this.currentTransition = newTransitionPresets[0].name;
        this.$_changeSelectedGroupName(this.currentTransition);
      }
    },

    autoShuffle() {
      this.$nextTick(() => {
        if (!this._isDestroyed) {
          $(this.$refs.tooltipBody).tooltip('show');
        }
      });
    },
  },

  methods: {
    $_shouldAutoShuffle() {
      const story = app.storyController.story;
      return !!story.get('transitionSelection').autoShuffle;
    },

    onToggleChange(shuffle) {
      this.autoShuffle = shuffle;
      this.$_onToggleChange(shuffle);
    },

    choosePresetGroup() {
      app
        .showModal({
          type: 'normal',
          component: ChooseTransition,
          componentPropsData: {
            transitionPresets: this.transitionPresets,
            currentTransition: this.currentTransition,
            autoShuffle: this.autoShuffle,
          },
          closeOnEscape: true,
          closeOnClickOut: false,
          showCloseButton: true,
        })
        .$on('close', ({ transitionName } = {}) => {
          if (_.isString(transitionName)) {
            this.$_changeSelectedGroupName(transitionName);
            this.currentTransition = transitionName;
            if (!this.autoShuffle) {
              this.onToggleChange(true);
            }
          }
        });
    },

    $_changeSelectedGroupName(transitionName) {
      if (typeof transitionName !== 'string') {
        return;
      }

      const story = app.storyController.story;
      const transitionSelection = story.get('transitionSelection');
      story.set(
        'transitionSelection',
        Object.assign({}, transitionSelection, {
          selectedPreset: transitionName,
        })
      );
      app.trigger('showTransitionsPopover');
      if (this.$_shouldAutoShuffle()) {
        app.timelineGateway.applyTransitionsWithShuffle();
      }
    },

    $_onToggleChange(shuffle) {
      const story = app.storyController.story;
      const transitionSelection = story.get('transitionSelection');
      app.analytics('transitions:auto:transitions', { isOn: !!shuffle });
      story.set(
        'transitionSelection',
        Object.assign({}, transitionSelection, {
          autoShuffle: shuffle,
        })
      );

      if (this.$_shouldAutoShuffle()) {
        app.timelineGateway.applyTransitionsWithShuffle();
      } else {
        app.timelineGateway.applyTransitionsWithRemove();
      }
    },
  },
});
</script>

<style lang="scss">
.tooltip.wt-preset-tooltip.large.-transition {
  pointer-events: none;
  margin-top: 10px; // move it down

  .tooltip-inner {
    max-width: 250px;
  }
}
</style>

<style lang="scss" scoped>
.wt-transition-button {
  align-items: center;
  display: flex;
  width: auto;
  justify-content: space-between;

  .wticon {
    padding-right: 10px;
    font-size: 16px;
  }

  .wt2-toggle-component {
    height: 20px;
    margin-left: 10px;
  }
}
</style>
